import React from 'react'
import { Toast, ToastProps } from '@dasa-health/components-react'
import { ToastLink } from './styles'

export interface GenericToastProps extends ToastProps {
    message?: string
    onRetryText?: string
    onRetry?: () => void | Promise<void>
    disabled?: boolean
}

export const GenericToast: React.VFC<GenericToastProps> = ({
    message = 'Ocorreu um erro',
    onRetry,
    onRetryText = 'Tentar novamente',
    variant = 'error',
    icon,
    disabled = false,
}) => {
    const handleClick = (e: React.SyntheticEvent) => {
        if (onRetry) {
            onRetry()
        }
        e.preventDefault()
    }

    return (
        <Toast css={{ position: 'fixed', top: '0', left: '0', zIndex: '200' }} icon={icon} variant={variant}>
            {message}
            {onRetry && (
                <ToastLink disabled={disabled} onClick={handleClick} title={onRetryText}>
                    {onRetryText}
                </ToastLink>
            )}
        </Toast>
    )
}

export default GenericToast
